import { findAllAreas } from '@src/main/modules/common/area/application/find/findAllAreas';
import { Area, AreaCreate, AreaDelete } from '@src/main/modules/common/area/domain/Area';
import { AreaRepository } from '@src/main/modules/common/area/domain/AreaRepository';
import { useError } from '@src/main/ui/components/common/error/hooks/useError';
import { useEffect, useState } from 'react';

export const useAreaUseCases = (areaRepository: AreaRepository) => {
  const [areas, setAreas] = useState<Area[] | undefined>();
  const { addError } = useError();

  useEffect(() => {
    reloadAreas(areaRepository, setAreas).catch(addError);
  }, [addError, areaRepository]);

  const addArea = async (area: AreaCreate) => {
    await areaRepository.put(area);
    if (areas) {
      await reloadAreas(areaRepository, setAreas);
    }
  };

  const deleteArea = async (area: AreaDelete) => {
    await areaRepository.delete(area);
    if (areas) {
      await reloadAreas(areaRepository, setAreas);
    }
  };

  return {
    areas,
    addArea,
    deleteArea,
  };
};

const reloadAreas = async (areaRepository: AreaRepository, setAreas: (areas: Area[]) => void) => {
  const areas: Area[] = await findAllAreas(areaRepository);
  areas.map((area) => {
    const subareas = area.subareas
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((subarea) => {
        const subsubareas = subarea.subsubareas.sort((a, b) => {
          if (a.name === 'Common') return -1;
          if (b.name === 'Common') return 1;

          if (subarea.id === '8a4a5248-56ce-32cd-800e-a335414f82c4') {
            const order = ['Financial Statements', 'Performance Analysis', 'IAG'];
            return order.indexOf(a.name) - order.indexOf(b.name);
          }

          return a.name.localeCompare(b.name);
        });
        return { ...subarea, subsubareas };
      });

    return { ...area, subareas };
  });
  setAreas(areas);
};
